/**
 * Simple logger interface for the wallet
 * Can be extended to support different log levels and outputs
 */

export enum LogLevel {
  DEBUG = 0,
  INFO = 1,
  WARN = 2,
  ERROR = 3
}

export interface Logger {
  debug(message: string, ...args: any[]): void
  info(message: string, ...args: any[]): void
  warn(message: string, ...args: any[]): void
  error(message: string, ...args: any[]): void
}

class ConsoleLogger implements Logger {
  constructor(private minLevel: LogLevel = LogLevel.INFO) {}

  debug(message: string, ...args: any[]): void {
    if (this.minLevel <= LogLevel.DEBUG) {
      console.log('[DEBUG]', message, ...args)
    }
  }

  info(message: string, ...args: any[]): void {
    if (this.minLevel <= LogLevel.INFO) {
      console.log('[INFO]', message, ...args)
    }
  }

  warn(message: string, ...args: any[]): void {
    if (this.minLevel <= LogLevel.WARN) {
      console.warn('[WARN]', message, ...args)
    }
  }

  error(message: string, ...args: any[]): void {
    if (this.minLevel <= LogLevel.ERROR) {
      console.error('[ERROR]', message, ...args)
    }
  }
}

// Default logger instance
export const logger: Logger = new ConsoleLogger(
  process.env.NODE_ENV === 'production' ? LogLevel.WARN : LogLevel.INFO
)

// Factory for creating custom loggers
export function createLogger(minLevel: LogLevel = LogLevel.INFO): Logger {
  return new ConsoleLogger(minLevel)
}